import webrtcAdapter from 'webrtc-adapter';
import { pipRequiresGestureTask } from 'utils/pip/pipRequiresGestureTask';

export type AutoPipStrategy = 'before' | 'during' | 'after';

export const getAutoPipStrategy = (isEmbedded: boolean): AutoPipStrategy => {
  if (isEmbedded && pipRequiresGestureTask()) {
    return 'before';
  }

  if (webrtcAdapter.browserDetails.browser === 'firefox') {
    return 'during';
  }

  return 'after';
};
